// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"AccountSupport-modalContainer","impersonationCode":"AccountSupport-impersonationCode","errorMessage":"AccountSupport-errorMessage"};